export const getFileNameFromUrl = (url: string): string => url.split('/').pop() ?? 'unknown';

export const mapIdsToQueryString = (ids: string[]): URLSearchParams => {
    const urlSearchParams = new URLSearchParams();
    ids.forEach(id => {
        urlSearchParams.append('id[]', id);
    });
    return urlSearchParams;
};

export const urlToBase64 = async (url: string): Promise<string> => {
    try {
        const response = await fetch(url, {
            mode: 'cors',
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Access-Control-Allow-Origin': '*',
            },
        });
        const blob = await response.blob();
        return await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = (): void => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error converting URL to base64:', error);
        return url;
    }
};

export const generateUrlWithQuery = (path: string, query: Record<string, any>): string => {
    const searchParams = new URLSearchParams();

    for (const key in query) {
        const value = query[key];
        if (value !== undefined && value !== null) {
            searchParams.set(key, String(value));
        }
    }

    const queryString = searchParams.toString();
    return queryString ? `${path}?${queryString}` : path;
};
